//@flow
import * as React from 'react'
import {connect} from 'react-redux'

import {type StoreState} from '$src/state/types'

export type Options = {
  authSelector: (state: StoreState, ownProps: Object) => mixed,
  onNoAuth: Function
}

type Props = {
  isAuthenticated: boolean,
  children: React.Node
}

const authWrapper = (options: Options) => (
  Component: React.ComponentType<any>
) => {
  class AuthWrapper extends React.Component<Props> {
    componentWillMount() {
      !this.props.isAuthenticated && options.onNoAuth(this.props)
    }

    componentWillReceiveProps(nextProps) {
      !nextProps.isAuthenticated && options.onNoAuth(nextProps)
    }

    render() {
      return <Component {...this.props} />
    }
  }

  const stateToProps = (state, ownProps: Object) => ({
    isAuthenticated: !!options.authSelector(state, ownProps),
  })

  return connect(stateToProps)(AuthWrapper)
}

export default authWrapper



// WEBPACK FOOTER //
// ./src/util/authWrapper.js